import { Activity, FirmRecord } from '@tassat/fred-definitions';

import { FirmActivityLogsAgGrid } from './firmActivityLogsAgGrid';

export interface FirmActivityLogsAgGridProps {
    activities: Activity[];
    exportData: boolean;
    setExportData: React.Dispatch<React.SetStateAction<boolean>>;
    firm: FirmRecord;
}

export default FirmActivityLogsAgGrid;